import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';

// Components 

import Box from '@mui/material/Box';
import Button from '../../../general/inputs/Button';
import { saveConsultationNote, updateConsultation } from '../../../../routes/doctor/consultation';
import { setIsConsent, setIsFileExplorerPopupOpened, setIsNoteExportPopupOpened } from '../../../../redux/features/doctor/Dashboard/consultation/consultation';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { setNotificationMessage } from '../../../../redux/features/general/notification';
import CircularProgress from '@mui/material/CircularProgress';
import ExportRow from './items/ExportRow';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import { resetFileExplorer, selectFile, setSearchSection } from '../../../../redux/features/doctor/Dashboard/documents/fileExplorer';
import { setIsLoadingPopupOpened } from '../../../../redux/features/general/navigation';
import CancelButton from '../../../general/inputs/CancelButton';

interface Props { 

}; 

const Export: React.FC<Props> = ({ }) => {

   const dispatch = useAppDispatch(); 
   const { t } = useTranslation(); 
   const navigate = useNavigate(); 
   const isMobile = useMediaQuery('(max-width: 900px)');

   const { consultationId, consultationNoteId } = useParams(); 

   const iframeRef = useRef<HTMLIFrameElement | null>(null);

   const colors = useAppSelector(state => state.theme.colors);

   const blobFile = useAppSelector(state => state.consultationNote.blobFile) as any; 
   const blobFileUrl = useAppSelector(state => state.consultationNote.blobFileUrl) as any; 

   const currentTitle = (document?.getElementById('note-title') as HTMLInputElement)?.value; 
   const currentDescription = (document?.getElementById('note-text') as HTMLInputElement)?.value;

   const [fileUrl, setFileUrl] = useState(''); 


   // -- 

   const handleTermination = async () => { 

       navigate('/dashboard'); 

       window.location.reload(); 

   }; 

   // --

   const saveNote = async () => { 

       dispatch(setIsLoadingPopupOpened(true)); 

       const formData = new FormData() as any; 

       formData.append('file', blobFile); 
       formData.append('consultationId', consultationId); 
       formData.append('consultationNoteId', consultationNoteId); 
       formData.append('title', currentTitle); 

       const res = await saveConsultationNote(formData) as any;

       dispatch(setIsLoadingPopupOpened(false)); 
       dispatch(setIsNoteExportPopupOpened(false)); 

       if (res.status === 200) {

           dispatch(setNotificationMessage(t('noteSaved'))); 

           dispatch(resetFileExplorer()); 

           dispatch(selectFile(res.data.file));
           dispatch(setSearchSection(res.data.file.folder)); 

           dispatch(setIsFileExplorerPopupOpened(true)); 

       };

   }; 

   // -- 

   const handleQuit = () => { 

       dispatch(setIsNoteExportPopupOpened(false)); 

   }; 

   // -- 

   useEffect(() => { 

       if (blobFileUrl) { 

           setFileUrl(blobFileUrl);

       }; 

   },[blobFileUrl]); 
    
    // -- 

    return (

        <Box 
           onClick={handleQuit}
            sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center', 
                justifyContent: 'center',
                width: '100vw',
                height: '100vh', 
                backgroundColor: colors?.popup, 
                overflow: 'hidden', 
                position: 'absolute', 
                zIndex: 100000000,
        }}>

            <Box
               onClick={(e) => e.stopPropagation()}
                sx={{ 
                   display: 'flex', 
                   flexDirection: isMobile ? 'column' : 'row',
                   alignItems: 'center', 
                   textAlign: 'center', 
                   width: isMobile ? '95vw' : '80vw', 
                   height: isMobile ? '90vh' : '80vh', 
                   borderRadius: 3,
                   fontSize: 14,
                   backgroundColor: colors?.container,
                   overflow: 'hidden',
                }}
            >

                <Box
                   sx={{ 
                       display: 'flex',
                       flexDirection: 'column',
                       alignItems: 'center', 
                       justifyContent: 'center',
                       height: isMobile ? '50%' : '100%', 
                       width: isMobile ? '100%' : '50%',
                   }}
                >
                   {fileUrl ?
                       <iframe
                       ref={iframeRef}
                       src={fileUrl}
                       style={{ 
                           width: '100%', 
                           height: '100%',
                           border: 'none'
                       }}
                       title="Note Viewer"
                       />: 
                   <CircularProgress size={30} />}
                </Box>

                <Box
                   sx={{ 
                       display: 'flex',
                       flexDirection: 'column',
                       alignItems: 'center', 
                       position: 'relative',
                       height: isMobile ? '50%' : '100%', 
                       width: isMobile ? '100%' : '50%',
                   }}
                >

                   <Box
                       sx={{ 
                           display: 'flex',
                           flexDirection: 'column',
                           alignItems: 'center', 
                           height: '100%', 
                           width: '100%',
                           paddingTop: isMobile ? 2 : 8, 
                       }}
                   >

                       {/* <ExportRow 
                           title='saveToFileExplorer'
                           icon={ <Box
                               component="img"
                               sx={{
                                   height: `${20}px`,
                                   width: 'auto',
                               }}
                               alt="Solutions Medca Inc."
                               src={require('../../../../assets/icons/files/folder.png')}
                           />}
                           handler={saveNote}
                           extraIcon={<DownloadOutlinedIcon sx={{ color: colors?.main }} />}
                       /> */}

                   </Box>

                   <Button 
                       title='terminateConsultation'
                       triggerFunction={handleTermination}
                       extraStyle={{ 
                           position: 'absolute',
                           right: 15,
                           bottom: 10, 
                       }}
                   />

                   <Box
                       component="img"
                       sx={{
                           height: `${15}px`,
                           width: 'auto',
                           position: 'absolute',
                           top: 15,
                           left: 15, 
                       }}
                       alt="Solutions Medca Inc."
                       src={require('../../../../assets/logos/medca_logo_blue_dark_blue.png')}
                   />

                </Box>

               <CancelButton handler={handleQuit} />

            </Box>
 
        </Box>

  );

};

export default Export;